// extracted by mini-css-extract-plugin
module.exports = {"sharebtn":"ShareModal_sharebtn__3xSk5","share-doc-modal":"ShareModal_share-doc-modal__1k0uf","ant-modal-content":"ShareModal_ant-modal-content__3ns1f"};